import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BazisContextMenuService } from '@bazis/shared/services/context-menu.service';
import { ContextMenuComponent } from '@bazis/shared/components/context-menu/context-menu.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'bazis-context-menus',
    templateUrl: './context-menus.component.html',
    imports: [ContextMenuComponent, CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenusComponent implements OnDestroy, OnInit {
    public contextMenuService = inject(BazisContextMenuService);

    ngOnInit(): void {}

    ngOnDestroy(): void {}
}
